import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { checkAuthStatus, setLoading } from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, token, isAuthenticated, isLoading } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    // Check authentication status on mount
    const checkAuth = async () => {
      try {
        await dispatch(checkAuthStatus()).unwrap();
      } catch (error) {
        // If check fails, user is not authenticated
        dispatch(setLoading(false));
      }
    };

    if (!user && token) {
      checkAuth();
    } else if (!token) {
      dispatch(setLoading(false));
    }
  }, [dispatch, user, token]);

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
  };
};
